import {createSelector} from "reselect";
import {UniqAnimalKey} from "../reducers/rfidHistoryReducer";

const defaultEmptyArray = [];

export const getAggData = (state, {[UniqAnimalKey]: key}) =>
    state.rfidHistory.data[key] || defaultEmptyArray

export const getFetching = (state, {[UniqAnimalKey]: key}) =>
    state.rfidHistory.fetching[key] || false

export const makeGetRFIDPigHistory = () => {
    return createSelector(
        [getAggData, getFetching],
        (_data, _fetching) => {
            return {
                data: _data,
                fetching: !!_fetching
            }
        });
}
